/* globals $ */
'use strict';

const { validContactForm } = require('../../lib/validators');

$(function () {
  const nameInput = $('#name');
  const emailInput = $('#email');
  const phoneInput = $('#phone');

  const inputs = [nameInput, emailInput, phoneInput];

  const isValidForm = () =>
    validContactForm(nameInput.val(), emailInput.val(), phoneInput.val());

  // Set button state
  const validateForm = () => $('#submit').prop('disabled', !isValidForm());

  // After each input change validate form
  inputs.forEach((input) => input.on('input', validateForm));

  // Set initial value
  validateForm();
});
